import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "backArrow",
  "use": "backArrow-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"backArrow\">\n<path d=\"M7.65625 9.90625L3.96875 6.03125L7.65625 2.125C8.125 1.625 8.09375 0.84375 7.59375 0.34375C7.09375 -0.125 6.3125 -0.09375 5.8125 0.40625L1.3125 5.15625C0.875 5.625 0.875 6.40625 1.3125 6.875L5.8125 11.625C6.0625 11.875 6.40625 12 6.71875 12C7.03125 12 7.34375 11.9062 7.59375 11.6875C8.09375 11.1875 8.125 10.4062 7.65625 9.90625Z\" fill=\"#26A69A\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/backArrow.svg
// module id = LKAt
// module chunks = 13